<template>
  	<v-app>
		<meeting-recording-system-bar v-if="app.theme_loaded"></meeting-recording-system-bar>
		<v-main v-if="app.theme_loaded" :class="getBackgroundClass">
			<router-view></router-view>
		</v-main>		
  	</v-app>
</template>

<script>
import MeetingRecordingSystemBar from './components/MeetingRecordingSystemBar.vue'
import { useAppStore } from './stores/app'

export default {
	name: 'AppRecording',
	components: {
		MeetingRecordingSystemBar,
	},
	created() {
		this.app = useAppStore()
	},
	data() {
		return {
			app: null,
		}
	},
	computed: {
		getBackgroundClass: function() {
			if(this.$vuetify.theme.themes.dark.background && this.$vuetify.theme.themes.dark.background != '')
				return 'background'
			return ''
		},
	},
	mounted: async function() {
		this.loadRoom()
		
		let whiteboardScript = document.createElement('script')
		whiteboardScript.setAttribute('src', 'https://www.whiteboard.team/dist/api.js')
		document.head.appendChild(whiteboardScript)
	},
	methods: {
		loadRoom: function() {
			this.app.loadRoom(this.$vuetify, this.$router)
		},
	},
	watch: {
		
	}
};
</script>

<style>
#wpadminbar {
	display: none;
}
</style>
